import Plan from "./Plan";

class Plans {
  constructor(private readonly _list: Plan[] = []) {
  }

  public isEmpty(): boolean {
    return this._list.length === 0;
  }

  get list(): Plan[] {
    return this._list;
  }
}

export default Plans;
